import type { AuthUser } from '../types/auth';

/** True when the API marks the account as verified. Unknown/missing → verified (legacy backends). */
export function isEmailVerified(user: AuthUser | null | undefined): boolean {
  if (!user) return false;
  const flags: unknown[] = [
    user.emailVerified,
    user.isEmailVerified,
    user.verified,
    user.email_verified,
  ];
  const defined = flags.filter((v) => v !== undefined && v !== null);
  if (defined.length === 0) return true;
  return defined.some(
    (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true'),
  );
}

export function userDisplayEmail(user: AuthUser | null | undefined): string {
  if (!user) return '';
  const e = user.email;
  return typeof e === 'string' ? e : '';
}
